import {ChangeDetectionStrategy, Component, computed, effect, inject, input, output, signal} from '@angular/core';
import {Router} from '@angular/router';
import {RoutesEnums} from '../../../../../../enums/RoutesEnums';
import {SortConditionsFieldsEnum} from '../../../../../../enums/SearchEnums';
import {ClosebySearchService} from '../../../../../../services/closeby-search.service';
import {UrlBuilderService} from '../../../../../../services/url-builder.service';
import {QueryParams} from '../../../../../../types/QueryParams';
import {SearchState} from '../../../../../../types/SearchState';
import {AppConfigService} from '../../../../../../services/app-config.service';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {CareproviderAddress} from '../../../../../../types/CareproviderAddress';
import {CareproviderUnitType} from '../../../../../../types/CareproviderUnitType';

@Component({
  selector: 'app-closeby-carousel-v3',
  templateUrl: './closeby-carousel-v3.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg bg-green-2 px-4 py-5 -mx-4 md:mx-0',
  },
})
export class ClosebyCarouselV3Component {
  public careproviderUnitId = input<number>(null);
  public address = input<CareproviderAddress>(null);
  public mainCaregiverUnitType = input<CareproviderUnitType>(null);

  public isPageWithSidebar = input<boolean>(false);
  public pageType = input<DLPageTypeEnum>(null);
  public puffsShowOnChange = output<boolean>();
  public dataLoaded = output<boolean>();
  public isDataLoaded = signal<boolean>(false);
  public location = computed<string>(
    () => this.address()?.city || this.address()?.municipality || this.address()?.county,
  );
  private closebySearchService = inject(ClosebySearchService);
  public closebyItems = this.closebySearchService.closebyItems;
  private isDataLoading = signal<boolean>(false);
  private routerLinkState = computed<SearchState>(() => ({
    caregiverUnitTypeUrlPath: this.mainCaregiverUnitType()?.urlPath,
    careServiceTypeUrlPath: '',
    symptomUrlPath: '',
    placeUrlPath: '',
    freeSearchTerm: '',
    sort: SortConditionsFieldsEnum.ES_SCORE,
    page: 1,
    pageSize: this.appConfigService.appConfig.pageSize,
    totalPages: 1,
    locationSearch: true,
    lat: this.address()?.latitude,
    lon: this.address()?.longitude,
    openNow: false,
    openWeekend: false,
    customerFeatureType: '',
    isValid: true,
    digitalPage: 1,
    distance: 1000,
    timeslot: null,
    forceContentPage: false,
    forceSearchResults: false,
    urlPath: '',
  }));
  public routerLink = computed<string[]>(() =>
    this.urlBuilderService.CreateSearchResultsRouterLink(this.routerLinkState(), ['/', RoutesEnums.SEARCH]),
  );
  public queryParams = computed<QueryParams>(() =>
    this.urlBuilderService.CreateSearchResultsQueryParams(this.routerLinkState()),
  );

  constructor(
    private router: Router,
    private urlBuilderService: UrlBuilderService,
    private appConfigService: AppConfigService,
  ) {
    effect(
      () => {
        if (this.careproviderUnitId()) {
          this.isDataLoading.set(true);
          this.closebySearchService.updateClosebyItems(this.careproviderUnitId(), this.pageType());
        }
      },
      {allowSignalWrites: true},
    );

    effect(
      () => {
        if (this.closebyItems() !== null) {
          this.puffsShowOnChange.emit(this.closebyItems().length > 0);
          if (this.isDataLoading()) {
            this.isDataLoading.set(false);
            this.isDataLoaded.set(true);
            this.dataLoaded.emit(true);
          }
        }
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  public onClick($event: Event) {
    this.router.navigate(this.routerLink(), {queryParams: this.queryParams()});
  }
}
